import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@/components/Navigation/Buttons/CartButton/cartButton.container"
    ).then((module) => ({
        default: module.CartButton
    }))
);
